import { render, staticRenderFns } from "./attorney-ordered-paid-assessment-letter.vue?vue&type=template&id=b0a4e224"
import script from "./attorney-ordered-paid-assessment-letter.vue?vue&type=script&lang=js"
export * from "./attorney-ordered-paid-assessment-letter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports